import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { useTheme } from 'styled-components';

import { clearAccessTokens, openWindow } from '@ecp/common/src/utils/utils';
import useLoginForward from '@ecp/common/src/hooks/useLoginForward';
import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextButton } from '@ecp/common/src/components/button/mo/TextButton';

import { withMobileStatus } from '@mo-recoil/system/selector';
import { myDeliveryPlaceListState } from '@mo-recoil/order/atom';
import { getIsLogin } from '@mo-recoil/common/user/selector';
import { useConfirmDialog } from '@mo-hooks/common/useModal';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import authApi from '@mo-apis/common/authApi';
import { PRIVACY_POLICY_TITLE, TERM_OF_USE_TITLE } from '@mo-components/system/const';

export default function SkypassTermsAndConditions() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { isMobileApp, agentType } = useRecoilValue(withMobileStatus);
  const { siteNumber } = useSiteInfo();
  const { showConfirmDialog } = useConfirmDialog();
  const loginForward = useLoginForward(siteNumber, showConfirmDialog);
  const isLogin = useRecoilValue(getIsLogin);

  const resetDeliveryPlaceList = useResetRecoilState(myDeliveryPlaceListState);
  const handleLogout = async () => {
    showConfirmDialog('로그아웃 하시겠습니까?', async () => {
      await authApi.logout();
      clearAccessTokens();
      resetDeliveryPlaceList();
      navigate('/logout');
    });
  };

  const handleLogin = async () => {
    clearAccessTokens();
    loginForward();
  };

  function onClickTermOfUse() {
    openWindow(
      isMobileApp,
      'https://www.koreanair.com/contents/footer/terms-and-policies/terms-of-use',
      '_blank',
      agentType
    );
  }

  function onClickPrivacyPolicy() {
    openWindow(
      isMobileApp,
      'https://www.koreanair.com/contents/footer/terms-and-policies/privacy-policy',
      '_blank',
      agentType
    );
  }

  return (
    <>
      <FlexBoxColumn background-color={theme.color.background.white} padding={'9px 20px 12px'} width={'100%'}>
        <FlexBox width={'100%'} flex-wrap={'wrap'}>
          {/* 이용약관 버튼 */}
          <Spacing right={18} width={'max-content'}>
            <TextButton
              textProps={{ weight: moTheme.font.weight.demiLight, height: moTheme.font.lineHeight.demiLight }}
              onClick={onClickTermOfUse}
            >
              {TERM_OF_USE_TITLE}
            </TextButton>
          </Spacing>

          {/* 개인정보처리방침 버튼 */}
          <Spacing right={18} width={'max-content'}>
            <TextButton
              textProps={{
                weight: moTheme.font.weight.bold,
                height: moTheme.font.lineHeight.demiLight,
                color: theme.color.primary,
              }}
              onClick={onClickPrivacyPolicy}
            >
              {PRIVACY_POLICY_TITLE}
            </TextButton>
          </Spacing>

          {isLogin ? (
            <Spacing right={18} width={'max-content'}>
              <TextButton
                textProps={{
                  size: moTheme.font.size.$13,
                  weight: moTheme.font.weight.demiLight,
                  color: theme.color.text.basic,
                }}
                onClick={handleLogout}
              >
                로그아웃
              </TextButton>
            </Spacing>
          ) : (
            <Spacing right={18} width={'max-content'}>
              <TextButton
                textProps={{
                  size: moTheme.font.size.$13,
                  weight: moTheme.font.weight.demiLight,
                  color: theme.color.text.basic,
                }}
                onClick={handleLogin}
              >
                로그인
              </TextButton>
            </Spacing>
          )}
        </FlexBox>
      </FlexBoxColumn>
    </>
  );
}
